import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomElement } from '../../classes';
import { ApiService } from '../../../../api/api.service';
import { ConfigService } from '../../../../config/config.service';
import { CategoryService } from '../../../../categories/services/category.service';
import { ApiCollection } from '../../../../api/collection';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TreeComponent),
    multi: true
};

@Component({
    selector: 'chassis-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, ApiService]
})
export class TreeComponent extends CustomElement implements OnInit {
    public showTree = false;

    @Input() endpoint: string;

    public nodes = [];

    public actualInitialValue;

    public options = {
        allowDrag: false,
        allowDrop: false,
        cssClasses: {
            'expanded': 'fal fa-caret-down',
            'collapsed': 'fal fa-caret-right',
        }
    };

    public constructor(
        protected categoryService: CategoryService,
        protected configService: ConfigService
    ) {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();

        this.loadNodes();

        this.initialValue.subscribe((initialValue) => {
            this.actualInitialValue = initialValue;

            if (this.nodes.length) {
                this.setDefaultChecks(this.actualInitialValue);
            }
        });
    }

    protected loadNodes() {
        if (this.endpoint) {
            const url = this.configService.get('api_url') + '/' + this.endpoint;

            this.categoryService.request('get', url, true).subscribe((entries: ApiCollection) => {
                this.nodes = entries.all();

                if (this.actualInitialValue) {
                    this.setDefaultChecks(this.actualInitialValue);
                }
            }, error => {
                console.error(error);
            });
        }
    }

    // public ngOnDestroy(): void {
    //
    // }

    /**
     * Triggered when checkbox value changed
     *
     * @param value
     * @param node
     */
    public checkboxNodeChanged(value, node) {

        this.selectChildren(node.id, this.nodes, value);
        this.setNgModelValue();

    }

    /**
     * Set the ngModelValue -> two-way-bind
     */
    public setNgModelValue() {
        this.val = this.getCheckedCategories(this.nodes);
    }

    public valueIsArray() {
        return typeof this.val === 'object';
    }

    /**
     * Get an array with all checked categories
     *
     * @param categories
     * @param checked
     * @returns {Array}
     */
    protected getCheckedCategories(categories, checked = []) {
        categories.forEach(category => {
            this.getCheckedCategories(category.children, checked);

            if (category.checked === true) {
                const cat = {id: category.id, name: category.name};
                checked.push(cat);
            }
        });

        return checked;
    }

    /**
     * Select all checkboxes of children from the given parent node id
     *
     * @param parentId
     * @param categories
     * @param check
     * @param inParent
     */
    public selectChildren(parentId, categories, check = false, inParent = false) {
        categories.forEach(category => {
            const matchParent = inParent || category.id === parentId;

            if (category.children) {
                this.selectChildren(parentId, category.children, check, matchParent);
            }

            if (matchParent) {
                category.checked = check;
            }
        });
    }

    protected setDefaultChecks(defaultNodes) {
        defaultNodes.forEach((node) => {
            this.selectChildren(node.id, this.nodes, true);
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/tree/tree.component.ts